// removed by extract-text-webpack-plugin
module.exports = {"Item":"_6QPUj","ItemVertical":"_1G1TH","ItemHorizontal":"_29-gb","Image":"_1QTcn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetail/HotelNav/HotelNavItem/HotelNavItem.scss
// module id = 915
// module chunks = 0